import React from "react";

function AstrologersCard({
  name,
  profileImage,
  price,
  expertise,
  experience,
  rating,
  online,
}) {
  return (
    // Main Card Container
    <div className="relative astrologers-card-box border border-gray-200 rounded-[20px] text-center w-full">
      <div className="relative z-10 flex flex-col items-center text-center p-4">
        {/* Rating Badge (Top Right) */}
        <div className="absolute top-4 right-4 bg-[#E3A82C] text-white web-body-md font-semibold px-2 py-1 rounded-full flex items-center gap-1">
          <img src="/images/star.svg" alt="star" />
          {rating}
        </div>

        {/* Profile Image (Centered with Status Dot) */}
        <div className="relative w-[98px] h-[98px] mt-8 mb-4">
          <div className="w-full h-full rounded-full overflow-hidden border-2 border-white shadow-md">
            <img
              src={profileImage}
              alt={`${name}'s profile`}
              className="w-full h-full object-cover"
            />
          </div>
          {/* Online Status Dot (Green) */}
          <div
            className={
              online
                ? "absolute bottom-[7px] right-[7px] w-4 h-4 bg-green-500 rounded-full border-2 border-white"
                : "absolute bottom-[7px] right-[7px] w-4 h-4 bg-red-500 rounded-full border-2 border-white"
            }
          ></div>
        </div>

        {/* Content */}
        <div className="space-y-1">
          <h3 className="web-h5 text-gray-950">{name}</h3>

          {/* Price */}
          <p className="web-h6 text-gray-950">₹{price}/min</p>

          {/* Expertise (Yantra) - Assuming this is a unique category color */}
          <p className="web-body-md text-secondary-950 mt-2">{expertise}</p>

          {/* Experience */}
          <p className="web-body-md text-gray-500 pt-1">
            Exp: {experience} yrs
          </p>
        </div>
      </div>
    </div>
  );
}

export default AstrologersCard;
